import helperFunctions from '../classes/HelperFunctions';
import AuthFunctions from '../classes/AuthFunctions';
import AccountFunctions from "../classes/AccountFunctions";

const methods = Object.assign({}, helperFunctions, AuthFunctions, AccountFunctions);

export default methods;
